import { get, post } from "api/axios-client";
import { SegmentChecklist } from "components/QueueBoard/models/workOrderTypes";
import { ChecklistTemplate } from "../types/checklistTypes";

const controllerUrl = "api/Checklist/";
const reportUrl = "api/Report/";
// Template search API
export const searchChecklistTemplates = async (
  searchRequest: string
): Promise<ChecklistTemplate[]> => {
  try {
    const { data } = await post(
      `${controllerUrl}SearchChecklistTemplates?searchTerm=${searchRequest}`
    );

    return data.content;
  } catch (error) {
    throw error;
  }
};

// Associate template to segment
export const associateTemplateToSegment = async (
  checklistObject: SegmentChecklist
): Promise<SegmentChecklist> => {
  try {
    const { data } = await post(
      `${controllerUrl}AssociateChecklistTemplate`,
      checklistObject
    );
    return data.content;
  } catch (error) {
    throw error;
  }
};

export const downloadCheckListReport = async <T = any>(
  attachmentIdentity: number,
  customFileName?: string
): Promise<T | void> => {
  try {
    const response = await get<Blob>(
      `${reportUrl}DownloadChecklistReport?attachmentIdentity=${attachmentIdentity}`,
      {
        responseType: "blob",
        timeout: 300000,
      }
    );
    const fileName = customFileName || `checklist_${attachmentIdentity}.pdf`;
    const blob = response.data;
    const blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(blobUrl);
    return;
  } catch (error) {
    throw error;
  }
};

// Deactivate (soft delete) a checklist template
export const deactivateChecklistTemplate = async (
  templateId: number,
  modifiedBy: string
): Promise<boolean> => {
  try {
    const { data } = await post(`${controllerUrl}DeactivateChecklistTemplate`, {
      templateId,
      modifiedBy,
    });
    return data.content;
  } catch (error) {
    throw error;
  }
};
